import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-school-app-alumni-dashboard',
  templateUrl: './school-app-alumni-dashboard.component.html',
  styleUrls: ['./school-app-alumni-dashboard.component.css']
})
export class SchoolAppAlumniDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
